import request from './request'
import AiRequest from './airequest'

export function loginApi(data) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data
  })
}

/**
 * 智能问数
 */
export function Airqst(data) {
  return AiRequest({
    url: '/api',
    method: 'post',
    data
  })
}

/**
 * 获取用户信息
 */
export function getUserInfo(params) {
  return request({
    url: '/api/user/info',
    method: 'get',
    params
  })
}
/**
 * 获取企业工商信息
 */
export function getQccInfo(params) {
  return request({
    url: '/api/linker/we_chat/client_qcc',
    method: 'get',
    params
  })
}


/**
 * 邮件信息
 */
export function mail_list(params) {
  return request({
    url: '/api/linker/we_chat/mail/mail_list',
    method: 'get',
    params
  })
}

/**
 * 邮箱登录
 */
export function mail_login(data) {
  return request({
    url: '/api/linker/we_chat/mail/login',
    method: 'post',
    data
  })
}
// mail/login

/**
 * 邮箱详情
 */
export function mail_detail(params) {
  return request({
    url: '/api/linker/we_chat/mail/mail_detail',
    method: 'get',
    params
  })
}

//
/**
 * 客户列表
 */
export function client(params) {
  return request({
    url: '/api/linker/we_chat/client',
    method: 'get',
    params
  })
}

//
/**
 * 客户列表2
 */
export function client2(params) {
  return request({
    url: '/api/linker/we_chat/user_saler_list',
    method: 'get',
    params
  })
}

export function set_client(data, method) {
  return request({
    url: '/api/linker/we_chat/client',
    method,
    data
  })
}
/**
 * 联系人列表
 */
export function client_user(params) {
  return request({
    url: '/api/linker/we_chat/client_user',
    method: 'get',
    params
  })
}

/**
 * 设置联系人
 */
export function set_client_user(data, method) {
  return request({
    url: '/api/linker/we_chat/client_user',
    method,
    data
  })
}

/**
 * 数据字典
 */

export function get_dictionary(params) {
  return request({
    url: '/api/get_dictionary_value_info',
    method: 'get',
    params
  })
}
//获取项目管理里程碑的数据字典
export function get_dictionary_all(params) {
  return request({
    url: 'api/get_dictionary_value_info_arr',
    method: 'get',
    params
  })
}
//项目文件的项目类型
export function get_project_type_tree(params) {
  return request({
    url: 'api/pms/get_project_type_tree',
    method: 'get',
    params
  })
}

/**
 * 销售区域
 */

export function sales_area(params) {
  return request({
    url: '/api/user/list/salesman',
    method: 'get',
    params
  })
}

// 根据区域获取销售员

export function get_zone_member(params) {
  return request({
    url: '/api/linker/we_chat/get_zone_member',
    method: 'get',
    params
  })
}

// 获取地区信息
export function region(params) {
  return request({
    url: '/api/region',
    method: 'get',
    params
  })
}

// calendar_app
/**
 *
 * 设置日程
 */
export function calendar_app(data, method) {
  return request({
    url: '/api/linker/we_chat/calendar_app',
    method,
    data
  })
}

export function get_Calendar_app(params) {
  return request({
    url: '/api/linker/we_chat/calendar_app',
    method: 'get',
    params
  })
}

export function get_user_list(params) {
  return request({
    url: '/api/linker/we_chat/user/list',
    method: 'get',
    params
  })
}
export function get_user_list2(params) {
  return request({
    url: '/api/linker/we_chat/user/list',
    method: 'get',
    params,
    loading: 'no'
  })
}
/**
 * 获取拜访记录
 */
export function get_visit_log_for_app(params) {
  return request({
    url: '/api/linker/we_chat/visit_log_for_app',
    method: 'get',
    params
  })
}

/**
 *新增拜访记录
 */
export function set_visit_log_for_app(data, method) {
  return request({
    url: '/api/linker/we_chat/visit_log_for_app',
    method: method,
    data
  })
}

/**
 * 获取打卡记录
 */

export function get_sing_in(params) {
  return request({
    url: '/api/linker/we_chat/sing_in',
    method: 'get',
    params
  })
}

/**
 * 获取评论
 */
export function get_business_comment(params) {
  return request({
    url: '/api/linker/we_chat/business_comment',
    method: 'get',
    params
  })
}

/**
 * 添加评论
 */
export function set_business_comment(data, method) {
  return request({
    url: '/api/linker/we_chat/business_comment',
    method,
    data
  })
}

/**
 * 驳回
 */
// talk_log_for_app
export function talk_log_for_app(data, method) {
  return request({
    url: '/api/linker/we_chat/talk_log_for_app',
    method,
    data
  })
}
/**
 * 洽谈记录
 */
export function get_talk_log_for_app(params) {
  return request({
    url: '/api/linker/we_chat/talk_log_for_app',
    method: 'get',
    params
  })
}
/**
 * 点赞
 */
export function set_like(data, method) {
  return request({
    url: '/api/linker/we_chat/like',
    method,
    data
  })
}
/**
 * 获取点赞
 */
export function get_like(params) {
  return request({
    url: '/api/linker/we_chat/like',
    method: 'get',
    params
  })
}

/**
 * 发送邮件
 */

export function send_email(data, method) {
  return request({
    url: 'api/linker/we_chat/mail/send_email',
    method,
    data
  })
}

// /api/file/add_file
export function flieUpload(data) {
  return request({
    url: '/api/file/add_file',
    method: 'POST',
    data
  })
}

/**
 * 清楚邮箱附件缓存
 */
//
export function email_new_msg_reset(data = {}) {
  return request({
    url: '/api/linker/we_chat/mail/email_new_msg_reset',
    method: 'post',
    data
  })
}

/**
 * 转发邮件附件
 */
export function reply_attach(data) {
  return request({
    url: '/api/linker/we_chat/mail/reply_attach',
    method: 'post',
    data
  })
}

/**
 * 删除附件
 */

/**
 * 删除邮件
 */
export function delete_email(data) {
  return request({
    url: '/api/linker/we_chat/mail/del_email',
    method: 'delete',
    data
  })
}

/**
 * 邮件附件删除
 */
export function mail_upload_delete(data) {
  return request({
    url: '/api/linker/we_chat/mail/mail_upload_delete',
    method: 'delete',
    data
  })
}

/**
 * 忘记密码
 */
export function reset_password(data) {
  return request({
    url: '/api/user/reset_password',
    method: 'post',
    data
  })
}

// /**
//  * 邮件附件上传
//  */

// export function email_fj()

/**
 * 库存量
 */
export function get_stock(params) {
  return request({
    url: '/api/linker/we_chat/goods/stock',
    method: 'get',
    params
  })
}

/**
 * 库存查询查看批号
 */

export function coa_download(params) {
  return request({
    url: '/api/erp/coa/download',
    method: 'get',
    params
  })
}

/**
 * 线索列表
 */
export function get_clue(params) {
  return request({
    url: '/api/linker/we_chat/clue',
    method: 'get',
    params
  })
}

export function set_clue(data, method) {
  return request({
    url: '/api/linker/we_chat/clue',
    method,
    data
  })
}

/**
 * 商机列表
 */
export function get_business(params) {
  return request({
    url: '/api/linker/we_chat/business',
    method: 'get',
    params
  })
}

export function set_business(data, method) {
  return request({
    url: '/api/linker/we_chat/business',
    method,
    data
  })
}

/**
 * 邮件置顶
 */
export function set_top(data) {
  return request({
    url: '/api/linker/we_chat/mail/set_top',
    method: 'put',
    data
  })
}

/**
 * 市场快讯
 */
export function market_info(params) {
  return request({
    url: '/api/linker/we_chat/market_info',
    method: 'get',
    params
  })
}

/**
 * 产品类别
 */
export function product_class(params) {
  return request({
    url: 'api/product/class',
    method: 'get',
    params
  })
}

/**
 * 产品类别扩展
 */
export function class_ext(params) {
  return request({
    url: 'api/product/class_ext',
    method: 'get',
    params
  })
}

/**
 * 获取产品列表
 */
export function product(params) {
  return request({
    url: 'api/product',
    method: 'get',
    params
  })
}

/**
 * 获取收藏列表
 */

export function collection(params) {
  return request({
    url: 'api/product/collection',
    method: 'get',
    params
  })
}

export function set_collection(data, method) {
  return request({
    url: 'api/product/collection',
    method,
    data
  })
}

/**
 * 样品列表1
 */
export function get_sample(params) {
  return request({
    url: 'api/linker/we_chat/sample',
    method: 'get',
    params
  })
}
/**
 * 样品列表2
 */
export function get_sample2(params) {
  return request({
    url: 'api/supplies_approval_list/front',
    method: 'get',
    params
  })
}

/**
 * 样品申请
 */
export function set_sample(data, method) {
  return request({
    url: 'api/linker/we_chat/sample',
    method,
    data
  })
}

/**
 * 获取申请组织
 */
export function get_department(params) {
  // a/?perPage=2&current_page=1&pid=0&structure_id=10&id=16
  return request({
    url: 'api/department',
    method: 'get',
    params
  })
}

/**
 * 公司类型
 */
export function sample_apply_company_config_list(params) {
  return request({
    url: 'api/linker/we_chat/sample_apply_company_config_list',
    method: 'get',
    params
  })
}

/**
 * 产品类别列表
 */
export function sample_product_class_list(params) {
  return request({
    url: 'api/sample_product_class_list',
    method: 'get',
    params
  })
}

/**
 * 产品类别配置
 */
export function sample_product_class_config(params) {
  return request({
    url: 'api/sample_product_class_config',
    method: 'get',
    params
  })
}

/**
 * 根据物料类型选择产品明细
 */

export function product_wl(params) {
  return request({
    url: 'api/linker/we_chat/sample_product',
    method: 'get',
    params
  })
}

/**
 * 审批
 */
export function supplies_approval_flow(data, method) {
  return request({
    url: 'api/supplies_approval_flow/front',
    method,
    data
  })
}

/**
 * 切换样品信息
 * @param {} data
 * @param {*} method
 * @returns
 */
export function changeSampleInfo(data, method) {
  return request({
    url: 'api/linker/we_chat/sample_up_params',
    method,
    data
  })
}

/**
 * 审批成本
 */
export function up_supplies_approval_cost(data, method) {
  return request({
    url: 'api/up_supplies_approval_cost/front',
    method,
    data
  })
}

/**
 * 详情页提交审核
 */

export function apply_check_up(data) {
  return request({
    url: 'api/linker/we_chat/apply_check_up',
    method: 'post',
    data
  })
}

/**
 * 转审
 */
export function sample_deliver_check(data, method) {
  return request({
    url: 'api/linker/we_chat/sample_deliver_check',
    method,
    data
  })
}

/**
 * 推送
 */
export function sample_push_send(data, method) {
  return request({
    url: 'api/linker/we_chat/sample_push_send',
    method,
    data
  })
}

/**
 * 催办
 */
export function sample_urge_handle(data, method) {
  return request({
    url: 'api/linker/we_chat/sample_urge_handle',
    method,
    data
  })
}

/**
 * 待办提醒
 */

export function notify_my_tasks(params) {
  return request({
    url: 'api/linker/we_chat/msg_notify/notify_my_tasks',
    method: 'get',
    params
  })
}

/**
 * 站内提醒
 */
export function get_user_msg_notify_list(params) {
  return request({
    url: 'api/linker/we_chat/msg_notify/get_user_msg_notify_list',
    method: 'get',
    params
  })
}

/**
 * 未读
 */
export function user_msg_read(data) {
  return request({
    url: 'api/linker/we_chat/msg_notify/user_msg_read',
    method: 'put',
    data
  })
}
// 获取物流信息
export function get_tracking_info(params) {
  return request({
    url: 'api/linker/we_chat/get_tracking_number_info',
    method: 'get',
    params
  })
}

/**
 * 修改个人资料
 */
export function edit_info(data) {
  return request({
    url: 'api/user/edit',
    method: 'put',
    data
  })
}

/**
 * 获取民族列表
 */
export function nation() {
  return request({
    url: 'api/nation_list',
    method: 'get'
  })
}

/**
 * 修改密码
 */
export function reset_pwd(data) {
  return request({
    url: 'api/user/reset_pwd',
    method: 'post',
    data
  })
}

/**
 * 客户拜访导出记录
 */
export function get_visit_export_log(params) {
  return request({
    url: 'api/linker/we_chat/get_visit_export_log',
    method: 'get',
    params
  })
}

/**
 * 统计
 */
export function statistics_data_module(data, method) {
  return request({
    url: 'api/linker/we_chat/statistics/statistics_data_module',
    method,
    data
  })
}

/**
 * 客户导出记录
 */
export function get_client_export_log(params) {
  return request({
    url: 'api/linker/we_chat/get_client_export_log',
    method: 'get',
    params
  })
}

/**
 * 导出市场易数据
 */

export function get_from_scy(params) {
  return request({
    url: 'api/linker/we_chat/client_user/from_scy',
    method: 'get',
    params
  })
}
/**
 * 抽奖设置
 */
export function award_settings(params) {
  return request({
    url: 'api/linker/we_chat/award_settings',
    method: 'get',
    params
  })
}

/**
 * 获取获奖名单
 */
export function lottery_draw(data) {
  return request({
    url: 'api/linker/we_chat/lottery_draw',
    method: 'post',
    data
  })
}
// api/linker/we_chat/end_lottery_draw
/**
 * 结束中奖
 * @returns
 */
export function end_lottery_draw(data) {
  return request({
    url: 'api/linker/we_chat/end_lottery_draw',
    method: 'post',
    data
  })
}

// 报价增删改
export function set_quotation(data, method) {
  return request({
    url: 'api/linker/we_chat/quotation',
    method,
    data
  })
}
// 获取报价
export function quotation(data, method) {
  return request({
    url: 'api/linker/we_chat/quotation',
    method,
    data
  })
}
// 获取报价 另一个接口（待我审批和我已审批）
export function quotation_review(params) {
  return request({
    url: 'api/linker/we_chat/quotation/review',
    method: 'get',
    params
  })
}
// 获取审批节点
export function get_node_list_quotation(params) {
  return request({
    url: 'api/linker/we_chat/quotation/node',
    method: 'get',
    params
  })
}
// 转审
export function transfer_quotation(data, method) {
  return request({
    url: 'api/linker/we_chat/quotation/transfer',
    method,
    data
  })
}
/**
 * 报价申请组织
 */
export function getcontractseller(params) {
  return request({
    url: 'api/linker/we_chat/contract/seller',
    method: 'get',
    params
  })
}
/**
 * 线索列表导出excel
 */
export function export_quotation(params) {
  return request({
    url: '/api/linker/we_chat/quotation',
    method: 'get',
    params,
    responseType: 'blob'
  })
}
/**
 * 线索列表
 */
export function get_quotation(params) {
  return request({
    url: '/api/linker/we_chat/quotation',
    method: 'get',
    params
  })
}
/**
 * 获取物料信息
 */
export function get_bd_material(params) {
  return request({
    url: 'api/linker/we_chat/bd_material',
    method: 'get',
    params
  })
}
/*
 * 获取销售区域列表
 */
export function sale_area_list(params) {
  return request({
    url: 'api/sale_area',
    method: 'get',
    params
  })
}
/**
 * 增加客户
 */
export function linker_client(data) {
  return request({
    url: 'api/linker/we_chat/client',
    method: 'post',
    data
  })
}
/**
 * 新增客户
 */
export function set_client_apply(data) {
  return request({
    url: 'api/linker/we_chat/client_apply',
    method: 'post',
    data
  })
}
/**
 * 修改客户
 */
export function change_client_apply(data) {
  return request({
    url: 'api/linker/we_chat/client_apply',
    method: 'put',
    data
  })
}
/**
 * 删除客户申请
 */
export function deleteClientApply(data) {
  return request({
    url: '/api/linker/we_chat/client_apply',
    method: 'delete',
    data
  })
}
/**
 * 查询客户申请列表
 */
export function get_client_apply_list(params) {
  return request({
    url: '/api/linker/we_chat/client_apply',
    method: 'get',
    params
  })
}
/**
 * 指派销售员
 */
export function linker_assign_user_id(data) {
  return request({
    url: 'api/linker/we_chat/assign_user_id',
    method: 'put',
    data
  })
}
/**
 * 获取销售部门列表
 */
export function get_sales_department_list(params) {
  return request({
    url: 'api/linker/we_chat/department_list',
    method: 'get',
    params
  })
}



/**
 * 审核通过、拒绝
 */
export function quotationReview(params) {
  return request({
    url: '/api/linker/we_chat/quotation/review',
    method: 'put',
    params
  })
}
// se
export function set_quotation_review(data, method) {
  return request({
    url: '/api/linker/we_chat/quotation/review',
    method,
    data
  })
}

// 发送报价单邮件

export function send_price_sheet(data, method) {
  return request({
    url: '/api/linker/we_chat/mail/send_email_for_price_sheet',
    method,
    data
  })
}
// 报价导出
export function quotation_exports(data, method) {
  return request({
    url: '/api/linker/we_chat/quotation',
    method,
    data
  })
}
// 获取差旅报销
export function get_trip_apply(params) {
  return request({
    url: 'api/linker/we_chat/trip_apply',
    method: 'get',
    params
  })
}
// 撤销差旅报销
export function trip_cancle(data, method) {
  return request({
    url: 'api/linker/we_chat/trip_apply_revocation',
    method,
    data
  })
}
export function getSaleAreaManagerList(params) {
  return request({
    url: '/api/sale_area_manager',
    method: 'get',
    params
  })
}
// 腾讯api传入起点终点获取路线规划
export function getDrivingInfo(params) {
  return request({
    url: 'api/linker/we_chat/get_mileage',
    method: 'get',
    params
  })
}
// 获取link下销售区域所在的关联人员
export const getlink_sales_dept_id_user = (params) => {
  return request({
    url: 'api/get_user',
    method: 'get',
    params
  })
}
// link 下创建群组关联
export const create_group_link = (data, method) => {
  return request({
    url: 'api/link_group',
    method,
    data
  })
}
// 获取群组关联
export const get_group_link = (params) => {
  return request({
    url: 'api/link_group',
    method: 'get',
    params
  })
}
// 创建link 
export const create_link = (data, method) => {
  return request({
    url: 'api/link',
    method,
    data
  })
}
// 获取link
export const get_link = (params) => {
  return request({
    url: 'api/link',
    method: 'get',
    params
  })
}
// 完成代办
export const complete_link = (data, method) => {
  return request({
    url: 'api/complete_link',
    method,
    data
  })
}

//解散群组获取未完成的待办
export const get_group_task = (data, method) => {
  return request({
    url: 'api/get_task',
    method,
    data
  })
}
// 获取返厂列表   api/demo_return
export const demo_return = (params) => {
  return request({
    url: 'api/demo_return',
    method: 'get',
    params
  })
}
// 线索 统计接口
export function getclueStatistics(params) {
  return request({
    url: "api/linker/we_chat/statistics/clue_statistics_data",
    method: "get",
    params
  })
}
// 商机统计接口
export function getbusinessStatistics(params) {
  return request({
    url: "api/linker/we_chat/statistics/businesses_statistics_data",
    method: "get",
    params
  })
}
// 线索与商机统计接口
export function getclueAndBusinessStatistics(params) {
  return request({
    url: "api/linker/we_chat/statistics/clue_businesses_statistics_data",
    method: "get",
    params
  })
}
// 样机管理
export function getSampleManagement(params) {
  return request({
    url: 'api/demo_operate',
    method: "get",
    params
  })
}
// 获取客户信息-线索/商机
export function visit_log_get_client_info(params) {
  return request({
    url: 'api/linker/we_chat/visit_log_get_client_info',
    method: "get",
    params
  })
}

/**
 * 全国区域下的统计数据
 */

export function get_blk_statistics_data_for_weekly(params) {
  return request({
    url: "/api/linker/we_chat/statistics/get_blk_statistics_data_for_weekly",
    method: "get",
    params
  })
}

/**
 * 数据看板
 */
export function get_blk_statistics_data_board(params) {
  return request({
    url: "api/linker/we_chat/statistics/get_blk_statistics_data_board",
    method: "get",
    params
  })
}

/**
 * 统计分析
 */
export function get_blk_statistics_data(params) {
  return request({
    url: "api/linker/we_chat/statistics/get_blk_statistics_data",
    method: "get",
    params
  })
}


// 产品统计
export function get_productstatistics_data(params) {
  return request({
    url: 'api/linker/we_chat/statistics/product_statistics_data',
    method: 'get',
    params
  })
}

//智能问答
export const aiquestion = (data, method) => {
  return request({
    url: 'api/chat',
    method,
    data,
    loading: 'no'
  })
}

// 播放转场动画
export const play_animation = (data, method) => {
  return request({
    url: 'api/user/play_animation',
    method,
    data,
  })
}

// 批量生成定制品待办表格
export const batch_link_ctable = (data, method) => {
  return request({
    url: 'api/batch_create_table',
    method,
    data
  })
}

// 多文件上传
export function multiple_upload_file(data) {
  return request({
    url: '/api/file/multiple_file_upload',
    method: 'post',
    data
  })
}

// 单文件上传
export function upload_file(data, method) {
  return request({
    url: '/api/file/add_file',
    method,
    data
  })
}

//批量下载图纸
export function multiple_download_file(data, method) {
  return request({
    url: '/api/link_file_download',
    method,
    data
  })
}

// 一键报价
export function click_linkto_quotation(params) {
  return request({
    url: "/api/link_to_quotations",
    method: "get",
    params
  })
}


// 刷新定制品待办表格 重新生成目录价等
export function updatebom_link(data, method) {
  return request({
    url: '/api/update_bom',
    method,
    data
  })
}

// 发送报价单邮件
export function send_quotation_email(data, method) {
  return request({
    url: '/api/linker/we_chat/mail/send_email_for_price_sheet',
    method,
    data
  })
}

// 将线索退回市场部
export function backclueto_market(data, method) {
  return request({
    url: '/api/linker/we_chat/clue_back',
    method,
    data
  })
}
// 产品资讯
export function product_info_for_app(params) {
  return request({
    url: '/api/linker/we_chat/product_info_for_app',
    method: "get",
    params
  })
}
// 产品资讯分类
export function product_info_class_for_app(params) {
  return request({
    url: '/api/linker/we_chat/product_info_class_for_app',
    method: "get",
    params
  })
}



// 一键改图
export function change_link(data, method) {
  return request({
    url: '/api/change_link',
    method,
    data
  })
}
// 获取出差列表
export function get_outvisit(params) {
  return request({
    url: '/api/linker/we_chat/trip',
    method: "get",
    params
  })
}

// 
export function set_outvisit(data, method) {
  return request({
    url: '/api/linker/we_chat/trip',
    method,
    data
  })
}

// 获取技术支持列表
export function gettuserlist(params) {
  return request({
    url: '/api/get_ts_user_for_sale_area',
    method: "get",
    params
  })
}

// pms 统计
export function getpmsproject(params) {
  return request({
    url: '/api/pms/projects/my_project_app',
    method: "get",
    params
  })
}

// pms 任务
export function getpmstask(params) {
  return request({
    url: '/api/pms/my_task_statistics',
    method: "get",
    params
  })
}

// pms度量
export function getpmsmeasurement(params) {
  return request({
    url: '/api/pms/projects/projects_map',
    method: "get",
    params
  })
}

export function getprojectsoverview(params) {
  return request({
    url: '/api/pms/projects/overview',
    method: "get",
    params
  })
}

export function get_hardware_info(data, method = 'post') {
  return request({
    url: '/api/get_hardware_info',
    method: method,
    data,
  })
}

export const getdrawsearch = (params) => {
  return request({
    url: '/api/file/public_disk_search',
    method: "get",
    params
  })
}


export const getdiskurl = (params) => {
  return request({
    url: '/api/file/public_disk_download',
    method: "get",
    params
  })
}


// 小工具   报价信息对比 货号查询
export const getquobymodel = (params) => {
  return request({
    url: '/api/linker/we_chat/tool/quotation',
    method: 'get',
    params
  })
}




// pms项目相关
// 立项列表
export function get_project_ratify(params) {
  return request({
    url: 'api/pms/project/project_ratify',
    method: 'get',
    params
  })
}
// 立项
export function project_ratify(data, method) {
  return request({
    url: 'api/pms/project/project_ratify',
    method,
    data
  })
}
// 项目
export function project_task(data, method) {
  return request({
    url: 'api/pms/project_task',
    method,
    data
  })
}
// 项目列表
export function get_project_task(params) {
  return request({
    url: 'api/pms/project_task',
    method: 'get',
    params
  })
}
// 项目预算列表
export function get_project_cost(params) {
  return request({
    url: 'api/pms/project/cost',
    method: 'get',
    params
  })
}
//项目预算编辑
export function project_cost(data, method) {
  return request({
    url: 'api/pms/project/cost',
    method,
    data
  })
}
//获取主项目列表
export function get_main_project_list(params) {
  return request({
    url: 'api/pms/parent_projects_all',
    method: 'get',
    params
  })
}
// 获取项目成员列表
export function project_member(params) {
  return request({
    url: 'api/pms/project/get_member',
    method: 'get',
    params
  })
}
// 获取任务成员列表
export function project_ratify_member(params) {
  return request({
    url: 'api/pms/project_ratify_member',
    method: 'get',
    params
  })
}
//项目统计
export function project_get_total(params) {
  return request({
    url: 'api/pms/project/get_total',
    method: 'get',
    params
  })
}
//任务概览
export function task_overview(params) {
  return request({
    url: 'api/pms/task_overview',
    method: 'get',
    params
  })
}
//审核立项申请
export function approval_check(data, method) {
  return request({
    url: 'api/approval_flow/approval_check',
    method,
    data
  })
}
//项目管理列表
export function get_projects(params) {
  return request({
    url: 'api/pms/projects',
    method: 'get',
    params
  })
}
//审核立项申请
export function projects(data, method) {
  return request({
    url: 'api/pms/projects',
    method,
    data
  })
}
//项目变更历史详情
export function projects_record(params) {
  return request({
    url: 'api/pms/projects/get_record',
    method: 'get',
    params
  })
}
//我的项目列表
export function my_project(params) {
  return request({
    url: 'api/pms/projects/my_project',
    method: 'get',
    params
  })
}
//变更列表
export function project_change(params) {
  return request({
    url: 'api/pms/projects/change',
    method: 'get',
    params
  })
}
//变更
export function pms_projects_change(data, method) {
  return request({
    url: 'api/pms/projects/change',
    method,
    data
  })
}
//我的任务
export function my_task(params) {
  return request({
    url: 'api/pms/my_task',
    method: 'get',
    params
  })
}
//项目投入概览
export function project_invest(params) {
  return request({
    url: 'api/pms/projects/project_invest',
    method: 'get',
    params
  })
}
//项目任务执行概览
export function execution_overview(params) {
  return request({
    url: 'api/pms/execution_overview',
    method: 'get',
    params
  })
}
//项目任务执行概览
export function projects_overview(params) {
  return request({
    url: 'api/pms/projects/overview',
    method: 'get',
    params
  })
}
//流程列表
export function get_approval_flow(params) {
  return request({
    url: 'api/approval_flow',
    method: 'get',
    params
  })
}
//流程操作
export function flow_approval(data, method) {
  return request({
    url: 'api/approval_flow',
    method,
    data
  })
}
//近期项目
export function recent_projects(params) {
  return request({
    url: 'api/pms/recent_projects',
    method: 'get',
    params
  })
}
//获取审核历史记录
export function approval_working_log(params) {
  return request({
    url: 'api/approval_flow/approval_working_log',
    method: 'get',
    params,
    loading: 'no'
  })
}
//获取流程配置
export function get_approval_flow_config(params) {
  return request({
    url: 'api/approval_flow_config',
    method: 'get',
    params
  })
}
//审批流流程操作
export function approval_flow_config(data, method) {
  return request({
    url: 'api/approval_flow_config',
    method,
    data
  })
}
//获取审批流程列表
export function get_approval_flow_list(params) {
  return request({
    url: 'api/approval_flow/list',
    method: 'get',
    params
  })
}
//获取项目列表-项目任务/项目变更侧边栏用
export function projects_side_list(params) {
  return request({
    url: 'api/pms/projects/side_list',
    method: 'get',
    params
  })
}
//新的项目任务侧边栏数据列表
export function projects_side_list_new(params) {
  return request({
    url: 'api/pms/projects/side_list_new',
    method: 'get',
    params
  })
}
//获取项目预算
export function projects_map(params) {
  return request({
    url: '/api/pms/projects/projects_map',
    method: 'get',
    params
  })
}


// 报价 小工具 导入 导出查询
export function set_quoinfo(data, method) {
  return request({
    url: '/api/linker/we_chat/tool/quotation',
    method,
    data
  })
}
//获取项目预算
export function purchase_list(params) {
  return request({
    url: '/api/pms/purchase/apply',
    method: 'get',
    params
  })
}



//获取审批流程列表
export function purchase_apply(data, method) {
  return request({
    url: 'api/pms/purchase/apply',
    method,
    data
  })
}



//获取我的审批
export function my_approval_working(params) {
  return request({
    url: '/api/approval_flow/my_approval_working',
    method: 'get',
  })
}


export function getdepartment(params) {
  return request({
    url: "api/department",
    method: "get",
    params,
  });
}
// 所属公司
export function zsy_company_all(params) {
  return request({
    url: "api/zsy_company_all",
    method: "get",
    params,
  });
}

export function getuserlist(params) {
  return request({
    url: "/api/linker/we_chat/user/list",
    method: "get",
    params,
  });
}
export function get_change_memeber(params) {
  return request({
    url: "api/pms/design/member",
    method: "get",
    params
  })
}
// 样机管理 获取 api/pms/prototype
export function get_prototype(params) {
  return request({
    url: 'api/pms/prototype',
    method: "get",
    params
  })
}
// 样机流转
export function prototype_flow(data, method) {
  return request({
    url: 'api/pms/prototype_flow',
    method,
    data
  })
}
// set 样机管理
export function set_prototype(data, method) {
  return request({
    url: 'api/pms/prototype',
    method,
    data
  })
}
// PMS 人员管理
export function get_project(params) {
  return request({
    url: "api/pms/project",
    method: "get",
    params
  })
}


// PMS 问题管理-项目问题管理
export function get_project_problem(params) {
  return request({
    url: "api/pms/errors",
    method: "get",
    params
  })
}


//客诉-编辑 
export function customer_complaint(data, method) {
  return request({
    url: 'api/pms/customer/complaint',
    method,
    data
  })
}

export function purchase_bd_material(params) {
  return request({
    url: '/api/bd_material/purchase',
    method: "get",
    params
  })
}


//申请采购
export function purchase(data, method) {
  return request({
    url: '/api/linker/we_chat/purchase',
    method,
    data
  })
}
//申请采购列表
export function get_purchase(params) {
  return request({
    url: '/api/linker/we_chat/purchase',
    method: "get",
    params
  })
}

// 获取报价信息 小工具导入模板
export function get_quo_template(params) {
  return request({
    url: '/api/linker/we_chat/tool/quotation/template',
    method: 'get',
    params
  })
}
// 获取产品资讯分类
export const get_product_info_class = (data) => {
  return request({
    url: '/api/product_info_class',
    method: 'get',
    data
  })
}
// 获取产品资讯
export const get_product_info = (params) => {
  return request({
    url: '/api/product_info',
    method: 'get',
    params
  })
}
// 更新产品资讯
export const update_product_info = (data, method) => {
  return request({
    url: '/api/product_info',
    method,
    data
  })
}
//客诉-审批后编辑
export function customer_complaint_add(data, method) {
  return request({
    url: 'api/pms/customer/complaint/add',
    method,
    data
  })
}
//获取物料分组信息
export const getMaterialGroup = (params) => {
  return request({
    url: 'api/bd_material_group',
    method: "get",
    params
  })
}
// 添加修改删除物料分组
export const setMaterialGroup = (data, method) => {
  return request({
    url: 'api/bd_material_group',
    method,
    data,
  })
}
// 获取物料信息
export const getMaterial = (params) => {
  return request({
    url: 'api/bd_material',
    method: "get",
    params
  })
}
//添加编辑或删除物料
export const setMaterial = (data, method) => {
  return request({
    url: 'api/bd_material',
    method,
    data,
  })
}
// 获取物料bom分组信息
export const getMaterialBomGroup = (params) => {
  return request({
    url: 'api/bom_group',
    method: "get",
    params
  })
}
// 添加修改删除物料分组信息
export const setMaterialBomGroup = (data, method) => {
  return request({
    url: 'api/bom_group',
    method,
    data,
  })
}
// 获取物料清单信息
export const getMaterialBom = (params) => {
  return request({
    url: 'api/bom',
    method: "get",
    params
  })
}
// 添加修改编辑物料清单信息
export const setMaterialBom = (data, method) => {
  return request({
    url: 'api/bom',
    method,
    data,
  })
}

// 获取计量单位列表
export const getUnitList = (params) => {
  return request({
    url: 'api/erp/get_bd_unit',
    method: "get",
    params
  })
}


//客诉
export function get_customer_complaint(params) {
  return request({
    url: "api/pms/customer/complaint",
    method: "get",
    params
  })
}
// 获取常用菜单信息
export const getCommonMenu = (params) => {
  return request({
    url: 'api/auth/rule/simple',
    method: "get",
    params
  })
}

// 设置常用菜单信息
export const setCommonMenu = (data, method) => {
  return request({
    url: 'api/auth/rule/simple',
    method,
    data,
  })
}


// 主动更新物料分组
export function update_material_group(params) {
  return request({
    url: 'api/refresh_bd_group',

    method: "get",
    params
  })
}


//loading不显示
export function getuserlist2(params) {
  return request({
    url: "/api/linker/we_chat/user/list",
    method: "get",
    params,
    loading: 'no'
  });
}
/**
 * 获取编辑的申请内容
 */
export function get_apply(params) {
  return request({
    url: "api/pms/apply",
    method: "get",
    params
  })
}

/**
 * 获取文件编号
 */
export function get_file_number() {
  return request({
    url: "api/pms/apply/file/number",
    method: "get"
  })
}

/**
 * 获取变更申请详情
 */
export function get_apply_detail(params) {
  return request({
    url: "api/pms/apply/detail",
    method: "get",
    params
  })
}

/**
 * 变更申请审批
 */
export function approve(data, method) {
  return request({
    url: "api/pms/apply/approve",
    method,
    data
  })
}
export function get_change_memeber2(params) {
  return request({
    url: "api/pms/design/member",
    method: "get",
    params,
    loading: 'no'
  })
}
// PMS 问题管理-项目问题管理
export function get_common_problem(params) {
  return request({
    url: "api/pms/common_error",
    method: "get",
    params
  })
}

export function get_condition_name(params) {
  return request({
    url: "api/pms/errors_search",
    method: "get",
    params
  })
}

export function add_or_edit_project_problem(data) {
  return request({
    url: "api/pms/errors",
    method: "post",
    data
  })
}

export function add_or_edit_common_problem(data) {
  return request({
    url: "api/pms/common_error",
    method: "post",
    data
  })
}

export function delete_problem(data) {
  return request({
    url: "api/pms/errors",
    method: "delete",
    data
  })
}

// PMS 人员管理


export function get_project_member(params) {
  return request({
    url: "api/pms/project_member",
    method: "get",
    params
  })
}
export function set_project_member(data, method) {
  return request({
    url: "api/pms/project_member",
    method,
    data
  })
}


export function add_or_edit_project(data) {
  return request({
    url: "api/pms/project",
    method: "post",
    data
  })
}

export function add_or_edit_project_member(data) {
  return request({
    url: "api/pms/project_member",
    method: "post",
    data
  })
}

export function delete_project(data) {
  return request({
    url: "api/pms/project",
    method: "delete",
    data
  })
}

export function delete_project_member(data) {
  return request({
    url: "api/pms/project_member",
    method: "delete",
    data
  })
}
//变更申请 角色列表
export function change_member(data, method) {
  return request({
    url: "api/pms/design/member",
    method,
    data
  })
}

// 主动更新成本价
export function update_erp_cost(params) {
  return request({
    url: 'api/refresh_erp_price',
    method: "get",
    params
  })
}


// 主动更新物料
export function update_material_list(params) {
  return request({
    url: 'api/refresh_bd_material',
    method: "get",
    params
  })
}


//下载导入模板 （物料）
export function download_material_modelexportin(params) {
  return request({
    url: 'api/bd_material/material_download',
    params,
    method: "get",
  })
}
// erp申请组织
export function get_apply_branch(params) {
  return request({
    url: 'api/linker/we_chat/apply_branch',
    method: "get",
    params
  })
}
//订单列表
export function get_order_list(params) {
  return request({
    url: 'api/linker/we_chat/order',
    method: "get",
    params
  })
}
export const order = (data, method) => {
  return request({
    url: 'api/linker/we_chat/order',
    method,
    data,
  })
}
//根据规格型号查找标准品和定制品 
export function get_list(params) {
  return request({
    url: 'api/linker/we_chat/contract/get_list',
    method: "get",
    params
  })
}
//拉取金蝶客户数据(同步至百林客)
export function get_kingdee_operator_sync(params) {
  return request({
    url: 'api/linker/we_chat/kingdee_operator_sync',
    method: "get",
    params
  })
}

//合同列表
export const getcontract = (params) => {
  return request({
    url: "/api/linker/we_chat/contract",
    params,
    method: "get",
  })
}

// set 合同
export const setcontract = (data, method) => {
  return request({
    url: "/api/linker/we_chat/contract",
    method,
    data,
  })
}

// 获取项目列表
export const getprojecttlist = (params) => {
  return request({
    url: "/api/pms/projects",
    params,
    method: "get",
  })
}

// 报价一键转合同
export const quotations_to_contract = (params) => {
  return request({
    url: "/api/linker/we_chat/quotations_to_contract",
    params,
    method: "get",
  })
}

// 根据规格型号查找标准品和定制品
export const get_standard_custom = (params) => {
  return request({
    url: "/api/linker/we_chat/contract/get_list",
    params,
    method: "get",
  })
}

// 获取销售组织
export const get_sale_area_group = (params) => {
  return request({
    url: "/api/linker/we_chat/apply_branch",
    params,
    method: "get",
  })
}

// 根据金蝶 销售组织获取销售员列表 
export const get_sale_staff_by_jd = (params) => {
  return request({
    url: "/api/linker/we_chat/kingdee_operator_sync",
    params,
    method: "get",
  })
}

// 获取销售部门  审批用
export const get_sale_dept = (params) => {
  return request({
    url: "/api/approval_flow/get_sales_department",
    params,
    method: "get",
  })
}


// 流程审核
export const approval_flow = (data, method) => {
  return request({
    url: "/api/approval_flow/approval_check",
    method,
    data,
  })
}

// 获取审核历史记录
export const get_approval_history = (params) => {
  return request({
    url: "/api/approval_flow/approval_working_log",
    params,
    method: "get",
  })
}

export const approval_cancel = (data, method) => {
  return request({
    url: "/api/approval_flow/approval_cancel",
    method,
    data,
  })
}

// 获取客户列表
export function get_client_list(params) {
  return request({
    url: '/api/linker/we_chat/get_client_list',
    params,
    method: "get",
  })
}
//获取客户分组列表
export function get_client_group_list(params) {
  return request({
    url: 'api/linker/we_chat/client_map',
    params,
    method: "get",
  })
}

// 物料清单导出全部
export function export_all_bom(params) {
  return request({
    url: 'api/export_all',
    method: 'get',
    params
  })
}

// 获取物料清单bom固定子项信息
export function get_bom_item_fix(params) {
  return request({
    url: 'api/get_bom_item',
    method: "get",
    params
  })
}
// 获取物料清单bom检测费用
export function get_bom_check(params) {
  return request({
    url: 'api/get_bom_item_check',
    method: "get",
    params
  })
}
// 获取箱物料清单纸箱和托盘
export function get_box_pallets(params) {
  return request({
    url: 'api/get_box_pallets',
    method: "get",
    params
  })
}

//产品管理 产品列表
export function get_product(params) {
  return request({
    url: "api/product",
    method: "get",
    params
  })
}
// 产品管理 
export function set_product(data, method) {
  return request({
    url: "api/product",
    method,
    data
  })
}

/**
 * 编辑申请内容
 */
export function apply(data, method) {
  return request({
    url: "api/pms/apply",
    method,
    data
  })
}

// 获取标准品列表的权限接口 以及导出 导出全部的接口
export function getProduct_list(params) {
  return request({
    url: 'api/product_auth',
    method: "get",
    params
  })
}

// 产品管理 导入之下载模板
export function download_product(params) {
  return request({
    url: "api/product/download",
    method: 'get',
    params
  })
}

// 更新库存
export function refreshStock_normal(method, data) {
  return request({
    url: "api/product/inventory",
    method: method ? method : 'POST',
    data
  })
}

// 获取库存日志列表以及导入日志列表 标准品页面
export function getLog_normal(params) {
  return request({
    url: "api/product/inventory",
    method: 'get',
    params
  })
}
// 获取产品类别新的接口
export function getProduct_auth(params) {
  return request({
    url: 'api/product/class_auth',
    method: "get",
    params
  })
}

// 定价策略列表
export function pricing_strategy(params) {
  return request({
    url: 'api/pricing_strategy',
    method: 'get',
    params
  })
}
// 定价策略设置
export function set_pricing_strategy(data, method) {
  return request({
    url: 'api/pricing_strategy',
    method,
    data
  })
}
// 变更申请导出
export function apply_export(data, method) {
  return request({
    url: 'api/pms/apply/export',
    method,
    data
  })
}
export function getkplist(params) {
  return request({
    url: "api/hr/assessment",
    method: "get",
    params,
  });
}
//获取已用设备
export function equipment(params) {
  return request({
    url: "api/erp/equipment",
    method: "get",
    params,
  });
}
export function add_assessment(data, method) {
  return request({
    url: "api/hr/assessment",
    method,
    data,
  });
}

export function approval_copy_add(data) {
  return request({
    url: "api/approval/approval_copy_add",
    method: "post",
    data,
  });
}

export function approvals_flow(data) {
  return request({
    url: "api/approval/approval_flow",
    method: "post",
    data,
  });
}

export function quarter_summary() {
  return request({
    url: "api/quarter_summary",
    method: "get",
  });
}
export function add_quarter_summary(data, method) {
  return request({
    url: "api/quarter_summary",
    method,
    data,
  })
}
//库存
export function inventory(params) {
  return request({
    url: "api/erp/inventory",
    method: "get",
    params,
  });
}
//设备领用
export function setlingyong(data, method) {
  return request({
    url: "api/erp/inventory",
    method,
    data,
  });
}

//打印配置增删改查
export function erp_configs(data, method) {
  return request({
    url: "api/erp/printer",
    method,
    data,
  });
}

//新增编辑/库存
export function setInventory(data, method) {
  return request({
    url: "api/erp/equipment",
    method,
    data,
  });
}

export function setlog(data, method) {
  return request({
    url: "api/erp/equipment/log",
    method,
    data,
  });
}

export function getlog(params) {
  return request({
    url: "api/erp/equipment/log",
    method: "get",
    params,
  });
}
// 标签打印
export function erp_get(params) {
  return request({
    url: "api/erp/order",
    method: "get",
    params,
  });
}
export function getunconfirm(params) {
  return request({
    url: "api/erp/determined",
    method: "get",
    params,
  });
}
// 标签打印编辑
export function seterp(data, method) {
  return request({
    url: "api/erp/order",
    method,
    data,
  });
}

// 标签打印拉取最新数据
export function erp_update(params) {
  return request({
    url: "api/input_info/update",
    method: "get",
    params,
  });
}
export function setunconfirm(params, method) {
  return request({
    url: "api/erp/determined",
    method,
    params,
  });
}
// 新增产品资讯分类
export const update_product_info_class = (data, method) => {
  return request({
    url: '/api/product_info_class',
    method,
    data,
  });
}

// 打印配置
export function erp_config(params) {
  return request({
    url: "api/erp/printer",
    method: "get",
    params,
  });
}
export function get_department_list(params) {
  return request({
    url: "api/linker/we_chat/department_list",
    method: "get",
    params,
  });
}

//产品名称列表
export function erp_product_get(params) {
  return request({
    url: "api/erp/edit",
    method: "get",
    params,
  });
}

//订单 新增
export function erp_product_post(data, method) {
  return request({
    url: "api/erp/edit",
    method,
    data,
  });
}

// 收料通知单   
export function get_take_up_info(params) {
  return request({
    url: "api/erp/get_take_up_info",
    method: "get",
    params
  })
}

//编辑收料通知单
export function set_take_up_info(data, method) {
  return request({
    url: "api/erp/get_take_up_info",
    method,
    data
  })
}

//根据销售出库单号导出文档
export function export_out_order(data, method) {
  return request({
    url: '/api/linker/we_chat/word',
    method,
    data
  })
}

/**
 * 获取打印配置
 */
export function get_print_config(params) {
  return request({
    url: "api/erp/print_config",
    method: "get",
    params
  })
}
/**
 * 设置打印配置
 */
export function set_print_config(data, method) {
  return request({
    url: "api/erp/print_config",
    method,
    data
  })
}

/**
 * 主动更新金蝶的数据
 */
export function get_storage_data(params) {
  return request({
    url: "api/erp/get_storage_data",
    method: "get",
    params
  })
}
// 生产领料单
export function get_prd_pick(params) {
  return request({
    url: "api/erp/prd_pick",
    method: "get",
    params,
  });
}

// 编辑生产领料单
export function set_prd_pick(data, method) {
  return request({
    url: "api/erp/prd_pick",
    method,
    data,
  });
}
//项目问题管理的成员
export function errors_assign(params) {
  return request({
    url: "api/pms/errors_assign",
    method: "get",
    params
  })
}

// 获取待我处理列表合集
export function get_my_list(params) {
  return request({
    url: "api/user/to_check",
    method: "get",
    params
  })
}
//个人投入-人员列表
export function projectsMember(params) {
  return request({
    url: "api/pms/projects/member",
    method: "get",
    params
  })
}
//获取个人投入
export function personalInput(params) {
  return request({
    url: "api/pms/projects/personal_input",
    method: "get",
    params
  })
}
//获取个人投入
export function projectsSatistics(params) {
  return request({
    url: "api/pms/projects/statistics",
    method: "get",
    params
  })
}

// 将客户数据同步至金蝶
export function syncCustomerKingdee(data, method) {
  return request({
    url: "api/linker/we_chat/client_kingdee",
    method,
    data,
  })
}

// 小工具-BOM数量 
export function getbomnum(params) {
  return request({
    url: "api/linker/we_chat/tool/bom",
    method: "get",
    params
  })
}

// bom下载模板
export function download_bom_modelexportin(params) {
  return request({
    url: "api/linker/we_chat/tool/bom/template",
    method: "get",
    params
  })
}
// 用户消息一键已读
export function readAllMessage(data, method) {
  return request({
    url: "api/linker/we_chat/msg_notify/user_msg_read_all",
    method,
    data, 
  })
}
// 客户拜访-浏览记录
export function get_visit_read_log(params) {
  return request({
    url: "api/linker/we_chat/get_visit_read_log",
    method: "get",
    params
  })
}


// 生产订单 
export function get_prd_mo(params) {
  return request({
    url: "api/erp/prd_mo",
    method: "get",
    params
  })
}

// 领取生产订单
export function set_prd_mo(data, method) {
  return request({
    url: "api/erp/prd_mo",
    method,
    data,
  })
}

// hr单点登录
export function hr_login(params) {
  return request({
    url: "api/auth_login",
    method: "get",
    params
  })
}
// 研发项目
export function get_apply_projects(params) {
  return request({
    url: "api/linker/we_chat/purchase/apply_projects",
    method: "get",
    params
  })
}
// 获取客户项目
export function get_client_project(params) {
  return request({
    url: "api/linker/we_chat/client_project",  
    method: "get",
    params
  })
}
// 获取销售员
export function get_user_form_sale_area(params) {
  return request({
    url: "api/get_user_form_sale_area",
    method: "get",
    params
  })
}
//新建客户项目
export function set_client_project(data, method) {
  return request({
    url: "api/linker/we_chat/client_project",
    method,
    data,
  });
}
// 待办更新价格
export const linkupdateprice = (data, method) => {
	return request({
		url:'api/update_bd_materia',
    method,
    data,
  })
}
// 获取销售员产品分类
export function class_salesman(params) {
  return request({
    url: "api/product/class/salesman",
    method: "get",
    params
  })
}
export const getcustomTypeInfo = (params) => {
	return request({
		url: 'api/linker/we_chat/client_type',
    method: "get",
    params
  })
}
// 报价审批退回上一个节点
export function quotationReturn(data, method) {
  return request({
    url: "api/linker/we_chat/quotation/return",
    method,
    data,
  })
}
// 图纸配件库查询 
export function get_drawing_parts(params) {
  return request({
    url: "api/linker/we_chat/tool/drawing_parts_inventory",
    method: "get",
    params
  })
}

// 获取城市列表
export function city_list(params) {
  return request({
    url: "api/city",
    method: "get",
    params
  })
}
// 报销--获取公司配置
export function reimburse_company(params) {
  return request({
    url: "api/reimburse_company", 
    method: "get",
    params
  })
}

// 获取公司列表
export function zsy_company(params) {
  return request({
    url: "api/zsy_company",
    method: "get",
    params
  })
}
export function business_trip(params) {
  return request({
    url: "api/linker/we_chat/business_trip",
    method: "get",
    params
  })
}
export function set_business_trip(data, method) {
  return request({
    url: "api/linker/we_chat/business_trip",
    method,
    data,
  });
}
 // 报销
export const set_reimburse = (data, method) => {
  return request({
    url: 'api/reimburse',  
    method,
    data,
  })
}

// 报销--列表
export function get_reimburse(params) {
  return request({
    url: "api/reimburse",
    method: "get",
    params
  })
}
// 报销公司列表
export function get_reimburse_structure_company(params) {
  return request({
    url: "api/reimburse_structure_company",
    method: "get",
    params
  })
}

export function get_business_trip(params) {
  return request({
    url: "api/linker/we_chat/business_trip",
    method: "get",
    params
  })
}
// 客诉-产品经理
export function get_complaint_product(params) {
  return request({
    url: "api/pms/customer/complaint/product",
    method: "get",
    params
  })
}
export function user_reset_default_pwd(data, method) {
  return request({
    url: "api/user/user_reset_default_pwd",
    method,
    data,
  });
}
export function deluser(data) {
  return request({
    url: "api/user/del",
    method: "delete",
    data,
  });
}
export function ding(params) {
  return request({
    url: "api/ding",
    method: "get",
    params,
  });
}
//获取部门管理列表 
export function zsy_ou(params) {
  return request({
    url: "api/zsy_ou",
    method: "get",
    params
  })
}
export function zsy_position(params) {
  return request({
    url: "api/zsy_position",
    method: "get",
    params
  })
}
// 获取公司配置列表
export function getcompany_configlist(params) {
  return request({
    url: 'api/company_config',
    method: 'get',
    params
  })
}
export function getzhiwei(params) {
  return request({
    url: "api/position",
    method: "get",
    params,
  });
}
export function getrole(params) {
  return request({
    url: "api/auth/role",
    method: "get",
    params,
  });
}
// 业务招待-列表
export function get_business_entertainment(params) {
  return request({
    url: "api/linker/we_chat/business_entertainment",
    method: "get",
    params
  })
}
// 业务招待--设置
export const set_business_entertainment = (data, method) => {
  return request({
    url: 'api/linker/we_chat/business_entertainment',
    method,
    data,
  })
}

export function set_zsy_ou(data, method) {
  return request({
    url: "api/zsy_ou",
    method,
    data,
  })
}
// 生产订单标签打印编辑
export function edi_prd_mo(data, method) {
  return request({
    url: "api/erp/prd_mo/relation",
    method,
    data,
  })
}

export function set_zsy_company(data, method) {
  return request({
    url: "api/zsy_company",
    method,
    data,
  })
}
// 生产订单二维码
export function get_prd_mo_qrcode(params) {
  return request({
    url: "api/erp/prd_mo/qrcode",
    method: "get",
    params
  })
}
export function register(data, method) {
  return request({
    url: "api/user/register",
    method,
    data,
  });
}
// 客诉-组织架构
export function get_complaint_company(params) {
  return request({
    url: "api/pms/customer/complaint/company",
    method: "get",
    params
  })
}
//客诉-转审
export function complaint_exchange(data, method) {
  return request({
    url: "api/pms/customer/complaint/exchange",
    method,
    data,
  })
}
//项目工时统计
export function get_project_work_hours(params) {
  return request({
    url: "api/pms/projects/get_project_work_hours",
    method:'get',
    params,
  })
}
export function pull_zsy_people(data, method) {
  return request({
    url: "api/people",
    method,
    data,
  })
}
//转审
export function approval_change(data, method) {
  return request({
    url: "api/approval_flow/approval_change",
    method,
    data,
  })
}
//报销-项目列表
export function reimburse_side_list(params) {
  return request({
    url: "api/reimburse/side_list",
    method: "get",
    params,
  })
}

//报销-用户列表
export function user_list_simple(params) {
  return request({
    url: "api/linker/we_chat/user/list/simple",
    method: "get",
    params,
  })
}
export function get_print_printer(params) {
  return request({
    url: "api/erp/print/printer",
    method: "get",
    params
  })
}
export function set_print_printer(data, method) {
  return request({
    url: "api/erp/print/printer",
    method,
    data,
  })
}
export function get_print_printer_const(params) {
  return request({
    url: "api/erp/print/printer/const",
    method: "get",
    params
  })
}
export function printaction(data,method){
  return request({
    url:'api/erp/print',
    method,
    data,
  })
}
export function set_projects_meeting(data,method){
  return request({
    url:'api/pms/projects_meeting',
    method,
    data,
  })
}
export function projects_meeting(params) {
  return request({
    url:'api/pms/projects_meeting',
    method: "get",
    params
  })
}

export function ctrip(params){
  return request({
    url:'api/ctrip',
    method: "get",
    params
  })
}
export function get_reimburse_user(params){
  return request({
    url:'api/reimburse_user',
    method: "get",
    params
  })
}
//报销--导入记录查询
export function get_reimburse_import(params){
  return request({
    url:'api/reimburse_import',
    method: "get",
    params
  })
}
//报销-取-季度可选人员获
export function get_reimburse_other_type_check(params){
  return request({
    url:'api/reimburse_other_type_check',
    method: "get",
    params
  })
}
//报销--出差目的地
export function get_reimburse_buss_trip(params){
  return request({
    url:'api/reimburse_buss_trip',
    method: "get",
    params
  })
}
//报销--获取人员职级标准
export function get_reimburse_user_level(params){
  return request({
    url:'api/reimburse_user_level',
    method: "get",
    params
  })
}
export function printpreview(data, method) {
  return request({
    url: "api/erp/print/preview",
    method,
    data,
  })
}


//提交评审
export function submit_project_review(data,method){
  return request({
    url:'api/pms/projects_meeting/review',
    method,
    data,
  })
}
// 催办
export function approval_urge(data, method) {
  return request({
    url: "api/approval_flow/approval_urge",
    method,
    data,
  })
}

// 总结评审
export function end_project_review(data,method) {
  return request({
    url: "api/pms/projects_meeting/end",
    method,
    data,
  })
}

// 工时管理列表
export function declaration_manage_list(params) {
  return request({
    url: "api/pms/projects/declaration_manage_list",
    method: "get",
    params,
  })
}

export function declaration_list(params) {
  return request({
    url: "api/pms/projects/declaration_list",
    method: "get",
    params,
  })
}
export function create_declaration(data,method) {
  return request({
    url: "api/pms/projects/create_declaration",
    method,
    data,
  })
}
export function cancel_declaration(data,method) {
  return request({
    url: "api/pms/projects/cancel_declaration",
    method,
    data,
  })
}
export function audit_declaration(data,method) {
  return request({
    url: "api/pms/projects/audit_declaration",
    method,
    data,
  })
}
export function get_prd_pick_mtrl(params) {
  return request({
    url: "api/erp/prd_pick_mtrl",
    method: "get",
    params
  })
}
export function set_prd_pick_mtrl(data, method) {
  return request({
    url: "api/erp/prd_pick_mtrl",
    method,
    data,
  })
}
// 线索统计
export function clue_statistics(params) {
  return request({
    url: "api/linker/we_chat/clue_statistics",
    method: "get",
    params,
  })
}
export function get_team_list(params) {
  return request({
    url: "api/get_team_list",
    method: "get",
    params,
   })
}
export function get_side_project_list(params) {
  return request({
    url: "api/pms/projects/side_project_list",
    method: "get",
    params
  })
}
//销售链路数据看板
export function get_order_price_report(params) {
  return request({
    url: "api/linker/we_chat/get_order_price_report",
    method: "get",
    params
  })
}

//客户数据看板接口
export function get_client_data_board(params) {
  return request({
    url: "api/linker/we_chat/get_client_data_board",
    method: "get",
    params
  })
}
//客户数据看板接口--客户送样成本-样品申请个数
export function get_client_data_sample(params) {
  return request({
    url: "api/linker/we_chat/get_client_data_sample",
    method: "get",
    params
  })
}
//客户数据看板接口--客户送样成本-订单金额
export function get_client_data_order(params) {
  return request({
    url: "api/linker/we_chat/get_client_data_order",
    method: "get",
    params
  })
}
//销售标兵榜
export function get_sale_ranking_list(params) {
  return request({
    url: "api/linker/we_chat/sale_ranking_list",
    method: "get",
    params
  })
}
//获取销售区域组织/组织下区域/区域下客户
export function get_sale_area(params) {
  return request({
    url: "api/linker/we_chat/sale_area",
    method: "get",
    params
  })
}
//客户拜访 统计报表
export function get_visit_log_report(params) {
  return request({
    url: "api/linker/we_chat/get_visit_log_report",
    method: "get",
    params
  })
}
//销售链路 销售量看板
export function get_sales_total(params) {
  return request({
    url: "api/linker/we_chat/get_sales_total",
    method: "get",
    params
  })
}
//转化商机数量VS报价数量
export function get_sales_dashboard_data(params) {
  return request({
    url: "api/linker/we_chat/statistics/sales_dashboard_data",
    method: "get",
    params
  })
}

export function get_sales_dashboard_order_cost(params) {
  return request({
    url: "api/linker/we_chat/statistics/sales_dashboard_order_cost",
    method: "get",
    params
  })
}
export function get_sales_dashboard_order_cost_client(params) {
  return request({
    url: "api/linker/we_chat/statistics/sales_dashboard_order_cost_client",
    method: "get",
    params
  })
}
export function get_saleman_data_sample(params) {
  return request({
    url: "api/linker/we_chat/get_saleman_data_sample",
    method: "get",
    params
  })
}
// 获取区域列表
export function get_salearea_list(params) {
  return request({
    url: "api/linker/we_chat/sale_area",
    method: "get",
    params,
  })
}
export function get_plan_order(params) {
  return request({
    url: "api/erp/plan_order",
    method: "get",
    params,
  })
}
export function get_material_class(params) {
  return request({
    url: "api/linker/we_chat/goods/material_class",
    method: "get",
    params,
  })
}

export function template_list(params) {
  return request({
    url: "api/pms/projects_meeting/operate_template",
    method: "get",
    params,
  })
}
export function set_template(data,method) {
  return request({
    url: "api/pms/projects_meeting/operate_template",
    method,
    data,
  })
}
export function get_base_data(params) {
  return request({
    url: "api/pms/get_base_data",
    method: "get",
    params,
  })
}
export function declaration_prepare_data(params) {
  return request({
    url: "api/pms/declaration_prepare_data",
    method: "get",
    params,
  })
}
//立项申请发邮件
export function project_send_email(data) {
  return request({
    url: "api/pms/project/send_email",
    method: "post",
    data,
  })
}
//更新立项成员
export function project_edit_member(data) {
  return request({
    url: "api/pms/project/edit_member",
    method: "post",
    data,
  })
}
//项目文件
export function project_file(params) {
  return request({
    url: 'api/pms/project_file',
    method: 'get',
    params
  })
}
export function get_budget_report(params){
  return request({
    url: "api/budget_report",
    method: "get",
    params,
  })
}
export function set_budget(data,method) {
  return request({
    url: "api/budget_report",
    method,
    data,
  })
}
export function get_budget_adjust(params){
  return request({
    url: "api/budget_adjust",
    method: "get",
    params,
  })
}
export function set_budget_adjust(data,method) {
  return request({
    url: "api/budget_adjust",
    method,
    data,
  })
}
export function get_reimburse_department(params) {
  return request({
    url: "api/reimburse_department",
    method: "get",
    params,
  })
}
export function get_budget_subject(params) {
  return request({
    url: "api/budget_adjust_subject",
    method: "get",
    params,
  })
}
export function get_budget_entity(params) {
  return request({
    url: "api/budget_entity",
    method: "get",
    params,
  })
}
export function set_budget_entity(data,method) {
  return request({
    url: "api/budget_entity",
    method,
    data,
  })
}
export function get_budget_entity_select(params) {
  return request({
    url: "api/budget_entity_pull",
    method: "get",
    params,
  })
}
// 获取预算主体
export function get_all_entity(params) {
  return request({
    url: "api/budget_entity_all",
    method: "get",
    params,
  })
}
export function budget_adjust_annual(params){
  return request({
    url: "api/budget_adjust_annual",
    method: "get",
    params,
  })
}
// 预算明细导出
export function budget_adjust_export(params) {
  return request({
    url: "api/budget_entity_detail",
    method: "get",
    params,
  })
}
export function project_report(params) {
  return request({
    url: "api/budget_report_project",
    method: "get",
    params,
  })
}
export function set_project_report(data,method) {
  return request({
    url: "api/budget_report_project",
    method,
    data,
  })
}
export function project_report_all(params) {
  return request({
    url: "api/budget_report_project_all",
    method: "get",
    params,
  })
}
export function budget_report_log(params) {
  return request({
    url: "api/budget_report_log",
    method: "get",
    params,
  })
}
export function budget_report_reimburse(params) {
  return request({
    url: "api/budget_report_reimburse",
    method: "get",
    params,
  })
}
//获取部门管理智思云数据
export function post_zsy_ou(data) {
  return request({
    url: "api/zsy_ou",
    method: "post",
    data,
  });
}
export function budget_report_add(data,method) {
  return request({
    url: "api/budget_report/add",
    method,
    data,
  })
}
export function budget_report_project_add(data,method) {
  return request({
    url: "api/budget_report_project/add",
    method,
    data,
  })
}
export function approval_view(params) {
  return request({
    url: "api/approval_flow/approval_view",
    method: "get",
    params,
  })
}
export function budget_detail_update(data,method) {
  return request({
    url: "api/budget_detail/update",
    method,
    data,
  })
}
export function reimburse_user_check(params) {
  return request({
    url: "api/reimburse_user_check",
    method: "get",
    params,
  })
}
// 获取预算设置下的部门列表
export function budget_entity_department(params) {
  return request({
    url: "api/budget_entity_department",
    method: "get",
    params,
  })
}
export function reimburse_check(data,method) {
  return request({
    url: "api/reimburse/check",
    method,
    data,
  })
}
export function welfare_expense(params) {
  return request({
    url: "api/welfare_expense",
    method: "get",
    params,
  })
}
export function set_welfare_expense(data,method) {
  return request({
    url: "api/welfare_expense",
    method,
    data,
  })
}
export function welfare_expense_company_all(params) {
  return request({
    url: "api/welfare_expense/company_all",
    method: "get",
    params,
  })
}